import { inject, Injectable } from '@angular/core';
import { ComuneDTO } from '../models/comune.model';
import { Edificio } from '../models/edificio.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpParamsOptions } from '@angular/common/http';

const endpoint = 'edifici';

@Injectable({
  providedIn: 'root'
})
export class EdificiService {
  http = inject(HttpClient);
  
  getEdificiByComune(comune: ComuneDTO): Observable<Edificio[]> {
    const params: HttpParams = new HttpParams().set('comune', comune.denominazione);
    const headers = {};
    const httpOptions = {
      headers,
      params,
      reportProgress: true,
    };
    const url = `${environment.apiUrl}${endpoint}`;
    return this.http.get<Edificio[]>(url, httpOptions);
  }
}
